/**
 * Normalizzazione del codice promozionale, unica per tutto il checkout (devops #333).
 *
 * <p>Fino a qui ogni punto della catena teneva la sua copia della regola, e la regola era
 * `replace(/[^a-z0-9-]/g, '')`: tutto ciò che non fosse una lettera, una cifra o un trattino
 * spariva dal campo mentre il socio scriveva, senza un messaggio. Chi provava a digitare
 * `carmine.mensile.50` vedeva uscire `carminemensile50` e ne concludeva, giustamente, che il
 * campo «non prende i caratteri speciali» — ed è il motivo per cui la reception aveva smesso
 * di usare punti e trattini nei codici creati a mano.</p>
 *
 * <p>Qui resta un solo divieto, e riguarda caratteri che non si vedono: spazi, caratteri di
 * controllo e gli zero-width che arrivano incollati da WhatsApp. Toglierli non cambia il codice
 * che il socio crede di aver scritto, mentre lasciarli farebbe fallire il confronto esatto che
 * il server fa su `PromoCode.code`. Tutto il resto — trattino, punto, virgola, underscore,
 * accenti — passa così com'è.</p>
 *
 * <p>Il minuscolo non è una limitazione del campo ma la forma in cui i codici sono salvati:
 * `PromoCodeService` normalizza in minuscolo sia in scrittura sia in lettura, quindi
 * `Carmine-Mensile-50` e `carmine-mensile-50` sono lo stesso codice.</p>
 */

/**
 * Vero per i caratteri che non si vedono: spazi in ogni forma, caratteri di controllo, soft hyphen
 * e zero-width. Scritto per punti di codice invece che con una regex perché una classe di caratteri
 * con gli escape di controllo fa scattare no-control-regex / no-irregular-whitespace in lint.
 */
function invisibile(carattere) {
    if (/\s/.test(carattere)) return true;
    const punto = carattere.codePointAt(0);
    return punto <= 0x1f              // caratteri di controllo
        || punto === 0x7f             // DEL
        || punto === 0xad             // soft hyphen: si vede come niente, non come trattino
        || (punto >= 0x200b && punto <= 0x200d) // zero-width space / non-joiner / joiner
        || punto === 0x2060           // word joiner
        || punto === 0xfeff;          // BOM, tipico di un incolla
}

/**
 * @param {unknown} value testo grezzo del campo codice
 * @returns {string} codice confrontabile con quelli salvati, stringa vuota se non resta nulla
 */
export function normalizePromoCode(value) {
    try {
        return Array.from(String(value ?? ''))
            .filter((carattere) => !invisibile(carattere))
            .join('')
            .toLowerCase();
    } catch (e) {
        return '';
    }
}

export default normalizePromoCode;
